import alLogoUrl from "../../images/al-logo.svg";
import classNames from "classnames";
import csLogoUrl from "../../images/cs-logo-black-and-white.svg";
import css from "./AppHeader.module.css";
import { useAuthState } from "../../context/auth";

type AppHeaderProps = {
  className?: string;
};

/**
 * Renders the header which is absolutely positioned and fixed in height.
 */
const AppHeader = ({ className }: AppHeaderProps) => {
  const { currentUser, logout } = useAuthState();

  return (
    <header className={classNames(className, "shadow", css.header)}>
      <div className={css.container}>
        <div className="d-flex align-items-center gap-1">
          <img
            className={css["al-logo"]}
            alt="CivicScience Logo"
            src={alLogoUrl}
          />
          <h1 className={classNames(css.title, "d-none d-sm-block")}>
            AudienceLens
          </h1>
        </div>
        <div className="d-flex align-items-center">
          <div className={css["user-info-container"]}>
            <div>Hey, {currentUser?.firstName}</div>
            <button
              className={classNames("btn btn-link", css.logout)}
              onClick={logout}
            >
              LOGOUT
              <i className="fa-light fa-arrow-right-from-bracket ms-2" />
            </button>
          </div>
          <span className={css["account-name"]}>
            {currentUser?.account.name}
          </span>
          <img
            className={css["cs-logo"]}
            alt="CivicScience Logo"
            src={csLogoUrl}
          />
        </div>
      </div>
    </header>
  );
};

export default AppHeader;
